import { EXTERNAL_LINKS } from '@psyomics/ui-common';

import { Text } from '../../../../../../components/atoms/text/text';
import { ClinicalReferenceProps } from '../types';

export const ClinicalReference = ({ description, linkText }: ClinicalReferenceProps) => {
  return (
    <Text>
      {description}{' '}
      <a className="underline" href={EXTERNAL_LINKS.FURTHER_INFORMATION} rel="noopener noreferrer" target="_blank">
        {linkText}
      </a>
    </Text>
  );
};
